module.exports = __webpack_public_path__ + "static/media/Sean-Hetzel's-Resume.90222840.pdf";